module.exports = "<p>\n  notifications works!\n</p>\n"